export default __webpack_public_path__ + "static/media/prana07.e49330cf.JPG";